module.exports = __webpack_public_path__ + "img/placeholder.44a26464.png";